
import {GET_PRODUCT_LIST} from "../types/const.js";

let productList = null;

export default function product( state = productList , action ){
    if  ( action.type === GET_PRODUCT_LIST){
        productList  = action.aproduct;
        return productList;
    } else
        return state;
};


// WEBPACK FOOTER //
// ./src/client/reducers/product.js